import React from 'react';
import jMoment from 'moment-jalaali';
import { CartableRequestStatusCode, isRequestCancelable } from 'utility';
import Services from '../../services';
import { TableItemActionsNew } from '../../../../components';
import createToast from '../../../../components/Toast/Toast';
import { Icons , PriceLabel} from 'components';

const columns = (navigate, setDialog, updateTableData, actionsList , currencyText) => {
  const sendCancelingReq = async (reqID) => {
    try {
      await Services.cartableCancelRequest(reqID);
      createToast('موفق', 'درخواست با موفقیت لغو شد!', 'success')
      await updateTableData();
    } catch (e) {
      console.log(`error`, e);
    }
    setDialog({ title: '', content: '', open: false, onAccept: () => null });
  };

  const onCancelReq = (reqID) => {
    setDialog({
      title: 'لغو درخواست',
      content: `آیا از لغو درخواست شماره ${reqID} مطمئن هستید؟`,
      open: true,
      onAccept: () => sendCancelingReq(reqID)
    });
  };

  return ([{
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  }, {
    title: 'شناسه حساب',
    field: 'multiConfirmationSrvId',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.multiConfirmationUsageSrv?.multiConfirmationSrv?.id ? rd?.multiConfirmationUsageSrv?.multiConfirmationSrv?.id : '-'),
  }, {
    title: 'شناسه درخواست',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.multiConfirmationUsageSrv?.id ? rd?.multiConfirmationUsageSrv?.id : '-'),
  }, {
    title: 'تاریخ ایجاد درخواست',
    field: 'creationDate',
    filtering: false,
    sorting: false,
    align: 'center',
    // render: (rd) => (rd?.creationDate ? rd?.creationDate : '-'),
    render: (row) =>
      row?.multiConfirmationUsageSrv?.creationDate
        ? jMoment(new Date(parseInt(row?.multiConfirmationUsageSrv?.creationDate)))?.format(
          'dddd, jD jMMMM jYYYY',
        ) ?? '-'
        : '-',
  }, {
    title: 'درخواست دهنده',
    field: 'requester?.name',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) =>
      rd?.multiConfirmationUsageSrv?.requester?.name
        ? rd?.multiConfirmationUsageSrv?.requester?.name
        : '-',
  }, {
    title: 'تاریخ انقضا',
    field: 'expireDate',
    filtering: false,
    sorting: false,
    align: 'center',
    // render: (rd) => (rd?.expireDate ? rd?.expireDate : '-'),
    render: (row) =>
      row?.multiConfirmationUsageSrv?.expireDate
        ? jMoment(new Date(parseInt(row?.multiConfirmationUsageSrv?.expireDate)))?.format(
          'dddd, jD jMMMM jYYYY',
        ) ?? '-'
        : '-',
  }, {
    title: 'نوع تراکنش',
    field: 'typeTransaction',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (typeTransactions(rd?.multiConfirmationUsageSrv) || '-'),
  }, {
    title: 'وضعیت',
    field: 'statusCode',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) =>
      rd?.multiConfirmationUsageSrv?.statusCode
        ? CartableRequestStatusCode[rd?.multiConfirmationUsageSrv?.statusCode]
        : '-',
  }, {
    title: `مبلغ (${currencyText})`,
    field: 'amount',
    filtering: false,
    sorting: false,
    align: 'center',
    //render: (rd) => (rd?.multiConfirmationUsageSrv?.requiredInfoToConfirm?.amount ? rd?.multiConfirmationUsageSrv?.requiredInfoToConfirm?.amount : '-'),
    render: (rowData) =>  <PriceLabel amount={rowData?.multiConfirmationUsageSrv?.requiredInfoToConfirm?.amount || rowData?.multiConfirmationUsageSrv?.requiredInfoToConfirm?.totalAmount} /> || '-'


  }, ...(actionsList['detailsRequestCartbleBtn'] || actionsList['detailRequestsGuildBtn'] || actionsList['cancelRequestsGuildBtn'] ||
    actionsList['CancelRequestCartbleBtn'] ? [{
      title: 'عملیات',
      field: '',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
          title=""
          otherMenus={[
            {
              title: 'جزییات',
              isShow: !!(actionsList['detailsRequestCartbleBtn'] || actionsList['detailRequestsGuildBtn']),
              onClick: () => navigate(`/RequestPayDetails/${rowData.multiConfirmationUsageSrv.id}`)
            },
            {
              title: 'لغو درخواست',
              isShow: !!(actionsList['CancelRequestCartbleBtn'] || actionsList['cancelRequestsGuildBtn']),
              disabled: !isRequestCancelable(rowData?.multiConfirmationUsageSrv?.statusCode),
              onClick: () => onCancelReq(rowData.multiConfirmationUsageSrv.id),
            },
          ]}
        />
      ),

    }] : [])]);
}


const typeTransactions = (data) => {
  const statusCodeOptions = {
    'WithrawSingle': 'برداشت وجه تکی',
    'WithrawGroup': 'برداشت وجه گروهی',
    'delegationSingle': 'تفویض وجه تکی',
    'delegationwGroup': 'تفویض وجه گروهی',
    'transferSingle': 'انتقال وجه تکی',
    'transferGroup': 'انتقال وجه گروهی',
    'factor': ' فاکتور ',
    'vouverAmount': ' بن تخفیف مبلغی ',
    'vouverPercent': ' بن تخفیف درصدی ',
    'voucherCharge': ' بن شارژ ',


  };
  const typeCodeEnum = {
    'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE': 'MULTI_CONFIRMATION_TYPE_DELEGATION_RULE', //تفویض وجه
    'MULTI_CONFIRMATION_TYPE_TRANSFER': 'MULTI_CONFIRMATION_TYPE_TRANSFER',//, انتقال وجه
    'MULTI_CONFIRMATION_TYPE_SETTLEMENT': 'MULTI_CONFIRMATION_TYPE_SETTLEMENT',// برداشت وجه
    'MULTI_CONFIRMATION_TYPE_INVOICE': 'MULTI_CONFIRMATION_TYPE_INVOICE',//   فاکتور
    'MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER': 'MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER',// بن تخفیف مبلغی
    'MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER': 'MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER',//,بن تخفیف درصدی
    'MULTI_CONFIRMATION_TYPE_VOUCHER': 'MULTI_CONFIRMATION_TYPE_VOUCHER',// بن
  };
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_SETTLEMENT) { // برداشت
    if (data?.requestFile || data?.requestFileHashCode) { // گروهی
      return statusCodeOptions.WithrawGroup;
    } else { // تکی
      return statusCodeOptions.WithrawSingle;
    }
  }
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_DELEGATION_RULE) { // تفویض
    if (data?.requestFile || data?.requestFileHashCode) {    // گروهی
      return statusCodeOptions.delegationwGroup;
    } else { // تکی
      return statusCodeOptions.delegationSingle;
    }
  }
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_TRANSFER) { // انتقال
    if (data?.requestFile || data?.requestFileHashCode) { // گروهی
      return statusCodeOptions.transferGroup;
    } else { // تکی
      return statusCodeOptions.transferSingle;
    }
  }
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_INVOICE) { // فاکتور
    return statusCodeOptions.factor;
  }
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_AMOUNT_VOUCHER) { // بن تخفیف مبلغی
    return statusCodeOptions.vouverAmount;
  }
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_PERCENT_VOUCHER) { // بن تخفیف درصدی
    return statusCodeOptions.vouverPercent;
  }
  if (data?.multiConfirmationSrv?.typeCode == typeCodeEnum.MULTI_CONFIRMATION_TYPE_VOUCHER) { // بن  شارژ
    return statusCodeOptions.voucherCharge;
  }
}
const status = {
  MULTI_CONFIRMATION_VERIFY_TOOL_SMS: 'پیامک',
  MULTI_CONFIRMATION_VERIFY_TOOL_API: 'سرویس',
};
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
